module.exports = __webpack_public_path__ + "img/male10.b30f4a31.jpg";